import React, { useEffect, useState } from 'react'
import '../../style/detailed-view.scss'
import { useStyles } from '../../style/views'
import { BlueCheckBox, WhiteOutlineCheckbox } from '../Support/CustomElements'
import Typography from '@mui/material/Typography'

import IconButton from '@mui/material/IconButton'
import SvgIcon from '@mui/material/SvgIcon'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import CaretDownSvg from '../../assets/images/CaretDown.svg'
import {
    Alert,
    Autocomplete,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Fade,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    InputAdornment,
    InputLabel,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    Select,
    Snackbar,
    Switch,
    TextField,
    Tooltip,
} from '@mui/material/'
import Slide from '@mui/material/Slide'
import QuarterDatePicker from '../../utilities/quarterDatePicker'
import DateProgressBar from './DateProgressBar'
import StudyDetailsField from './StudyDetailsField'
import ActivityStatusField from './ActivityStatusField'
import ActivityTypeField from './ActivityTypeField'
import ActivityPopulationField from './ActivityPopulationField'
import ActivityFunctionField from './ActivityFunctionField'
import ActivityIntendedUseField from './ActivityIntendedUseField'
import ActivityCountriesField from './ActivityCountriesField'
import ActivityDateField from './ActivityDateField'
import ActivityPublicationField from './ActivityPublicationField'
import ActivityBudgetField from './ActivityBudgetField'
import ActivityStudyField from './ActivityStudyField'
import ActivityManagementField from './ActivityManagementField'
import ActivityDetailsField from './ActivityDetailsField'
import { quarterOfYear } from '../../utilities/helpers'
import endpoints from '../../API/endpoints'
import callAPI from '../../API/callSecureAPI'
import Link from '@mui/material/Link'
import { useAuth0 } from '../../contexts/auth0-context'
import store from '../../redux/store'
import _ from 'underscore'
import { useSelector } from 'react-redux'
import Chip from '@mui/material/Chip'
import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableBody from '@mui/material/TableBody'
import CreateButton from '../Buttons/CreateButton'
import { useIsRoadmapReadonly } from '../../shared/hooks/useIsRoadmapReadonly'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { ToggleButton, ToggleButtonGroup } from '@mui/lab'
import EventIcon from '@mui/icons-material/Event'
import GridViewIcon from '@mui/icons-material/GridView'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { setSettings } from '../../redux/actions'
import { useStrategy } from '../../shared/hooks/useStrategy'
import { useDeleteActivityMutation } from '../../shared/queries/useDeleteActivityMutation'
import { useUpdateActivityMutation } from '../../shared/queries/useUpdateActivityMutation'
import { useUpdateDeliverablesMutation } from '../../shared/queries/useUpdateDeliverablesMutation'
import { useDebounce } from '../../shared/hooks/useDebounce'
import { useCheckStudyNumberQuery } from '../../shared/queries/useCheckStudyNumberQuery'
import { useAutoLinkActivityToExternalSource } from '../../shared/queries/useAutoLinkActivityToExternalSource'
import { newLabelMapping } from '../../shared/helpers/mappers'
import useActivityStatuses from '../../shared/hooks/useActivityStatuses'
import useActivitiesDisplayName from '../../shared/hooks/useDisplayNames/variants/useActivitiesDisplayName'
import useDisplayNames from '../../shared/hooks/useDisplayNames/useDisplayNames'
import Box from '@mui/material/Box'
import CloseIcon from '@mui/icons-material/Close'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Linking from '../Linking'
import useInvalidateLinkingQueries from '../../shared/queries/linking/useInvalidateLinkingQueries'
import { ACTIVITY_SOURCE_CHIP_COLORS } from '../../shared/constants/activity'
import { SOURCE_CHIP_SX } from '../../shared/constants/integrations'
import ReactCountryFlag from 'react-country-flag'
import { ALL_COUNTRY_NAMES, normalizeCountries, resolveCountry } from '../../utilities/countryLookup'
import ActivityForm from './ActivityForm'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

dayjs.extend(utc)
dayjs.extend(timezone)

let columns = [
    { id: 'title', label: 'Title' },
    { id: 'type', label: 'Type' },
    // { id: 'dueDate', label: 'Due Date' },
    { id: 'status', label: 'Status' },
]

let categories = [
    '---',
    'Journal Pub',
    'Congress Pub',
    'HCEI 502(a)',
    'PIE',
    'Field Tools',
    'Label',
    'Dossier',
    'Abstract',
    'Poster',
    'Manuscript',
]

const initialPublicationState = {
    isPublication: false,
    Journal: false,
    Congress: false,
    Manuscript: false,
    Presentation: false,
    DataOnFile: false,
}

const MAX_PRIMARY_EVIDENCE = 3

function ActivityDetailedView({ activity, forceParentRefresh, closePanel, editing, setEditing, navigationStack }) {
    const classes = useStyles()
    const strategy = useStrategy()
    const { mutateAsync: deleteActivityMutation } = useDeleteActivityMutation()
    const { mutateAsync: updateActivityMutation } = useUpdateActivityMutation()
    const { mutateAsync: updateDeliverablesMutation } = useUpdateDeliverablesMutation()

    const isDarkMode = useSelector((state) =>
        !state.userRecord ? true : state?.userRecord?.isDarkMode === undefined ? true : state?.userRecord?.isDarkMode
    )
    // @REVIEW - why no checks for isSnapshotMode?
    const isReadonlyMode = useIsRoadmapReadonly()

    const [isLoaded, setIsLoaded] = useState(false)
    const { isAuthenticated, getTokenSilently } = useAuth0()

    const [statusValue, setStatusValue] = useState('')
    const [newStatusValue, setNewStatusValue] = useState('')

    const [forceRefresh, setForceRefresh] = useState(false)

    // const [editing, setEditing] = useState(false)
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [openErrorModal, setOpenErrorModal] = useState(false)
    const [saveError, setSaveError] = useState(null)

    const [activityTitle, setActivityTitle] = useState('')
    const [newActivityTitle, setNewActivityTitle] = useState('')

    const [budget, setBudget] = useState(0)
    const [newBudget, setNewBudget] = useState(0)

    const [category, setCategory] = useState('---')
    const [newCategory, setNewCategory] = useState('---')

    const [isFunction, setFunction] = useState('---')
    const [newFunction, setNewFunction] = useState('---')

    const [intendedUse, setIntendedUse] = useState({})
    const [newIntendedUse, setNewIntendedUse] = useState({})

    const [isPublication, setIsPublication] = useState(false)
    const [newIsPublication, setNewIsPublication] = useState(false)

    const [publication, setPublication] = useState(initialPublicationState)
    const [newPublication, setNewPublication] = useState(initialPublicationState)

    const [funded, setFunded] = useState(false)
    const [newFunded, setNewFunded] = useState(false)

    const [startDate, setStartDate] = useState(null)
    const [newStartDate, setNewStartDate] = useState(null)

    const [endDate, setEndDate] = useState(null)
    const [newEndDate, setNewEndDate] = useState(null)

    const [description, setDescription] = useState('')
    const [newDescription, setNewDescription] = useState('')

    const [studyNumber, setStudyNumber] = useState('')
    const [newStudyNumber, setNewStudyNumber] = useState('')
    const debouncedStudyNumber = useDebounce(newStudyNumber)
    const { data: studyNumberCheck, isFetching: studyNumberChecking } = useCheckStudyNumberQuery({
        studyNumber: debouncedStudyNumber,
        organizationId: activity.organizationId ?? '',
        excludeActivityId: activity._id,
    })

    // On save, silently look the study number up in GSL/Planisware and, on an
    // exact match, relabel this Atlas-native activity's source. Only applies to
    // activities with no source yet.
    const { autoLinkActivityToExternalSource } = useAutoLinkActivityToExternalSource()

    const [dataSource, setDataSource] = useState('')
    const [newDataSource, setNewDataSource] = useState('')

    const [isVendorStudy, setIsVendorStudy] = useState(false)
    const [newIsVendorStudy, setNewIsVendorStudy] = useState(false)

    const [corporateOrRnDGoal, setCorporateOrRnDGoal] = useState(false)
    const [newCorporateOrRnDGoal, setNewCorporateOrRnDGoal] = useState(false)

    const [vendorDetails, setVendorDetails] = useState('')
    const [newVendorDetails, setNewVendorDetails] = useState('')

    const [link, setLink] = useState('')
    const [newLink, setNewLink] = useState('')

    const [openDependencyModal, setOpenDependencyModal] = useState(false)
    const [checkedActivitiesMap, setCheckedActivitiesMap] = useState({})
    const [allOtherActivities, setAllOtherActivities] = useState([])
    const [dependencyList, setDependencyList] = useState([])

    const [deliverablesMap, setDeliverablesMap] = useState({})
    const [newDeliverablesMap, setNewDeliverablesMap] = useState({})
    const [openDeliverableDeleteModal, setOpenDeliverableDeleteModal] = useState(false)
    const [deleteDeliverableId, setDeleteDeliverableId] = useState('')

    const activitiesDisplayName = useActivitiesDisplayName()
    const { getDisplayName } = useDisplayNames()
    const providerNameLabel = getDisplayName('providerName', 'Provider Name')

    const [quarterOrMonth, setQuarterOrMonth] = useState('month')

    const [startDateCalendar, setStartDateCalendar] = useState(null)
    const [newStartDateCalendar, setNewStartDateCalendar] = useState(null)

    const [endDateCalendar, setEndDateCalendar] = useState(null)
    const [newEndDateCalendar, setNewEndDateCalendar] = useState(null)

    const [startError, setStartError] = React.useState(null)
    const [endError, setEndError] = React.useState(null)

    const [type, setType] = useState('---')
    const [newType, setNewType] = useState('---')

    const [population, setPopulation] = useState('---')
    const [newPopulation, setNewPopulation] = useState('---')

    const [anticipatedMessaging, setAnticipatedMessaging] = useState('')
    const [newAnticipatedMessaging, setNewAnticipatedMessaging] = useState('')

    const [outcomesEndpoints, setOutcomesEndpoints] = useState('')
    const [newOutcomesEndpoints, setNewOutcomesEndpoints] = useState('')

    const [titleLong, setTitleLong] = useState('')
    const [newTitleLong, setNewTitleLong] = useState('')

    const [indication, setIndication] = useState('')
    const [newIndication, setNewIndication] = useState('')

    const [therapeuticArea, setTherapeuticArea] = useState('')
    const [newTherapeuticArea, setNewTherapeuticArea] = useState('')

    const [genericName, setGenericName] = useState([])
    const [newGenericName, setNewGenericName] = useState([])

    const [compoundName, setCompoundName] = useState([])
    const [newCompoundName, setNewCompoundName] = useState([])

    const [affiliateName, setAffiliateName] = useState('')
    const [newAffiliateName, setNewAffiliateName] = useState('')

    const [providerName, setProviderName] = useState('')
    const [newProviderName, setNewProviderName] = useState('')

    const [sponsorType, setSponsorType] = useState('')
    const [newSponsorType, setNewSponsorType] = useState('')

    const [countries, setCountries] = useState([])
    const [newCountries, setNewCountries] = useState([])

    const [studyReportDate, setStudyReportDate] = useState(null)
    const [newStudyReportDate, setNewStudyReportDate] = useState(null)

    const [terminationDate, setTerminationDate] = useState(null)
    const [newTerminationDate, setNewTerminationDate] = useState(null)

    const [resultsAvailableForExternalUseDate, setResultsAvailableForExternalUseDate] = useState(null)
    const [newResultsAvailableForExternalUseDate, setNewResultsAvailableForExternalUseDate] = useState(null)

    const [studyOwner, setStudyOwner] = useState('')
    const [newStudyOwner, setNewStudyOwner] = useState('')

    const [plannedStartDate, setPlannedStartDate] = useState(null)
    const [newPlannedStartDate, setNewPlannedStartDate] = useState(null)

    const [plannedEndDate, setPlannedEndDate] = useState(null)
    const [newPlannedEndDate, setNewPlannedEndDate] = useState(null)

    const [source, setSource] = useState('')
    const [processingStatus, setProcessingStatus] = useState(null)
    const [newProcessingStatus, setNewProcessingStatus] = useState(null)

    const [externalId, setExternalId] = useState('')
    const [newExternalId, setNewExternalId] = useState('')

    const [patientStudy, setPatientStudy] = useState(false)
    const [newPatientStudy, setNewPatientStudy] = useState(false)

    const startErrorMessage = React.useMemo(() => {
        switch (startError) {
            case 'invalidDate': {
                return 'Invalid date'
            }
            default: {
                return ''
            }
        }
    }, [startError])

    const endErrorMessage = React.useMemo(() => {
        switch (endError) {
            case 'minDate': {
                return 'End is before Start'
            }
            case 'invalidDate': {
                return 'Invalid date'
            }
            default: {
                return ''
            }
        }
    }, [endError])

    const { invalidateLinkingQueries } = useInvalidateLinkingQueries()

    useEffect(() => {
        if (forceRefresh) {
            setForceRefresh(false)
        }

        if (!isAuthenticated || !activity) {
            return
        }
        getActivityData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activity, forceRefresh, isAuthenticated])

    // ActivityForm owns its own Cancel/Save/Delete buttons; the TablePanel header no longer renders them for activities

    async function getActivityData() {
        let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        updateState(activity)

        let incomingSettings = await callAPI(
            endpoints.getSettingsByOrganizationId.url + store.getState().strategy.organizationId,
            endpoints.getSettingsByOrganizationId.method,
            token
        )
        if (incomingSettings.success) {
            setSettings(incomingSettings.data)
        }

        setIsLoaded(true)

        let dependencies = await callAPI(
            endpoints.getLinkedActivities.url,
            endpoints.getLinkedActivities.method,
            token,
            { listOfActivities: activity.activityDependencies }
        )

        if (dependencies.success) {
            setDependencyList(dependencies.data)
        }

        let incomingActivities = await callAPI(
            endpoints.getActivitiesForTable.url + store.getState().strategy._id,
            endpoints.getActivitiesForTable.method,
            token
        )
        if (incomingActivities.success) {
            let allOtherActs = incomingActivities.data.filter((x) => x._id !== activity._id)
            setAllOtherActivities(allOtherActs)
            let tempMap = {}
            allOtherActs.map(
                (act) =>
                    (tempMap[act._id] =
                        activity.activityDependencies && activity.activityDependencies.includes(act._id))
            )
            setCheckedActivitiesMap(tempMap)
        }
    }

    function updateState(activity) {
        setActivityTitle(activity.title)
        setNewActivityTitle(activity.title)
        setBudget(activity.budget)
        setNewBudget(activity.budget)
        setCategory(activity.category)
        setNewCategory(activity.category)
        setFunction(activity.function)
        setNewFunction(activity.function)
        setIntendedUse(activity.intendedUse)
        setNewIntendedUse(activity.intendedUse)
        setFunded(activity.funded)
        setNewFunded(activity.funded)
        setDescription(activity.description)
        setNewDescription(activity.description)
        setIsPublication(activity.publication?.isPublication)
        setNewIsPublication(activity.publication?.isPublication)
        setPublication({ ...initialPublicationState, ...activity.publication })
        setNewPublication({ ...initialPublicationState, ...activity.publication })
        setStudyNumber(activity.studyNumber)
        setNewStudyNumber(activity.studyNumber)
        setDataSource(activity.dataSource)
        setNewDataSource(activity.dataSource)
        setIsVendorStudy(activity.vendor)
        setNewIsVendorStudy(activity.vendor)
        setCorporateOrRnDGoal(activity.corporateOrRnDGoal || false)
        setNewCorporateOrRnDGoal(activity.corporateOrRnDGoal || false)
        setVendorDetails(activity.vendorDetails)
        setNewVendorDetails(activity.vendorDetails)
        getDeliverables(activity.deliverables)
        setNewStatusValue(activity.status)
        setStatusValue(activity.status)
        setType(activity.type)
        setNewType(activity.type)
        setPopulation(activity.population)
        setNewPopulation(activity.population)
        setAnticipatedMessaging(activity.anticipatedMessaging ?? '')
        setNewAnticipatedMessaging(activity.anticipatedMessaging ?? '')
        setOutcomesEndpoints(activity.outcomesEndpoints)
        setNewOutcomesEndpoints(activity.outcomesEndpoints)
        setTitleLong(activity.titleLong ?? '')
        setNewTitleLong(activity.titleLong ?? '')
        setIndication(activity.indication ?? '')
        setNewIndication(activity.indication ?? '')
        setTherapeuticArea(activity.therapeuticArea ?? '')
        setNewTherapeuticArea(activity.therapeuticArea ?? '')
        setGenericName(activity.genericName ?? [])
        setNewGenericName(activity.genericName ?? [])
        setCompoundName(activity.compoundName ?? [])
        setNewCompoundName(activity.compoundName ?? [])
        setAffiliateName(activity.affiliateName ?? '')
        setNewAffiliateName(activity.affiliateName ?? '')
        setProviderName(activity.providerName ?? '')
        setNewProviderName(activity.providerName ?? '')
        setSponsorType(activity.sponsorType ?? '')
        setNewSponsorType(activity.sponsorType ?? '')
        setCountries(normalizeCountries(activity.countries))
        setNewCountries(normalizeCountries(activity.countries))
        setStudyReportDate(activity.studyReportDate ? dayjs.utc(activity.studyReportDate) : null)
        setNewStudyReportDate(activity.studyReportDate ? dayjs.utc(activity.studyReportDate) : null)
        setTerminationDate(activity.terminationDate ? dayjs.utc(activity.terminationDate) : null)
        setNewTerminationDate(activity.terminationDate ? dayjs.utc(activity.terminationDate) : null)
        setResultsAvailableForExternalUseDate(
            activity.resultsAvailableForExternalUseDate ? dayjs.utc(activity.resultsAvailableForExternalUseDate) : null
        )
        setNewResultsAvailableForExternalUseDate(
            activity.resultsAvailableForExternalUseDate ? dayjs.utc(activity.resultsAvailableForExternalUseDate) : null
        )
        setStudyOwner(activity.studyOwner ?? '')
        setNewStudyOwner(activity.studyOwner ?? '')
        setPlannedStartDate(activity.plannedStartDate ? dayjs.utc(activity.plannedStartDate) : null)
        setNewPlannedStartDate(activity.plannedStartDate ? dayjs.utc(activity.plannedStartDate) : null)
        setPlannedEndDate(activity.plannedEndDate ? dayjs.utc(activity.plannedEndDate) : null)
        setNewPlannedEndDate(activity.plannedEndDate ? dayjs.utc(activity.plannedEndDate) : null)
        setSource(activity.source ?? '')
        setProcessingStatus(activity.processingStatus ?? null)
        setNewProcessingStatus(activity.processingStatus ?? null)
        setExternalId(activity.externalId ?? '')
        setNewExternalId(activity.externalId ?? '')
        setPatientStudy(activity.patientStudy ?? false)
        setNewPatientStudy(activity.patientStudy ?? false)

        let formattedLink = function () {
            if (!activity.link || activity.link.length === 0) {
                return ''
            } else {
                return activity.link.includes('http://') || activity.link.includes('https://')
                    ? activity.link
                    : 'http://' + activity.link
            }
        }
        setLink(formattedLink)
        setNewLink(formattedLink)

        if (activity.startDate) {
            if (new Date(activity.startDate).getMinutes() === 1) {
                // specific date set
                setStartDateCalendar(dayjs.utc(activity.startDate))
                setNewStartDateCalendar(dayjs.utc(activity.startDate))
            } else {
                // quarter is set
                setQuarterOrMonth('quarter')
                setStartDate(activity.startDate)
                setNewStartDate(activity.startDate)
            }
        }
        if (activity.endDate) {
            if (new Date(activity.endDate).getMinutes() === 1) {
                // specific date set
                setEndDateCalendar(dayjs.utc(activity.endDate))
                setNewEndDateCalendar(dayjs.utc(activity.endDate))
            } else {
                // quarter is set
                setQuarterOrMonth('quarter')
                setEndDate(activity.endDate)
                setNewEndDate(activity.endDate)
            }
        }
    }

    async function getDeliverables(deliv) {
        let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        let incomingDeliverables = await callAPI(
            endpoints.getDeliverableList.url,
            endpoints.getDeliverableList.method,
            token,
            {
                listOfDeliverables: deliv,
            }
        )
        if (incomingDeliverables.success) {
            let tempMap = {}
            for (let deliv of [...incomingDeliverables.data]) {
                tempMap[deliv._id] = deliv
            }
            setDeliverablesMap({ ...tempMap })
            if (!editing) {
                setNewDeliverablesMap({ ...tempMap })
            }
        }
    }

    async function newDeliverable(incomingDeliverable) {
        if (isAuthenticated) {
            let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            await callAPI(
                endpoints.createDeliverable.url + activity._id,
                endpoints.createDeliverable.method,
                token,
                incomingDeliverable
            )
        }
        setEditing(false)
        // getActivityData()
        forceParentRefresh(true)
    }

    async function saveActivity(formData) {
        if (formData.startDate && formData.endDate && new Date(formData.startDate) > new Date(formData.endDate)) {
            setOpenErrorModal(true)
            return
        }
        setEditing(false)

        try {
            await updateActivityMutation({ activityId: activity._id, roadmapId: strategy._id, data: formData })
        } catch (err) {
            setSaveError(err.message ?? 'Failed to save activity')
            return
        }

        const changedDeliverables = {}
        for (const id of Object.keys(newDeliverablesMap)) {
            if (!_.isEqual(newDeliverablesMap[id], deliverablesMap[id])) {
                changedDeliverables[id] = newDeliverablesMap[id]
            }
        }
        if (Object.keys(changedDeliverables).length > 0) {
            try {
                await updateDeliverablesMutation({ deliverablesMap: changedDeliverables })
                setDeliverablesMap({ ...newDeliverablesMap })
            } catch (err) {
                setSaveError(err.message ?? 'Failed to save deliverables')
                return
            }
        }

        setSaveError(null)
        await autoLinkActivityToExternalSource({
            activityId: activity._id,
            roadmapId: strategy._id,
            studyNumber: formData.studyNumber,
            source,
        })
        setStartError(null)
        setEndError(null)
        invalidateLinkingQueries()
        // Don't locally merge formData into activity here — it can't know about fields
        // that changed as a side effect of the save (e.g. `source` from the auto-link
        // above), and would overwrite them with stale data. forceParentRefresh already
        // invalidates the activities query, and the effect watching `activity` re-runs
        // updateState once the fresh data flows back down.
        forceParentRefresh(true)
    }

    async function deleteTheActivity() {
        setOpenDeleteModal(false)
        await deleteActivityMutation({ activityId: activity._id, roadmapId: strategy._id, activityData: activity })
        invalidateLinkingQueries()
        forceParentRefresh(true)
        closePanel()
    }

    async function onNewDeliverable() {
        let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        const response = await callAPI(
            endpoints.createDeliverable.url + activity._id,
            endpoints.createDeliverable.method,
            token,
            {
                title: '---',
                type: '---',
                isComplete: false,
                strategyId: activity.strategyId,
                organizationId: activity.organizationId,
            }
        )
        if (response.success) {
            const deliv = response.data
            setDeliverablesMap((prev) => ({ ...prev, [deliv._id]: deliv }))
            setNewDeliverablesMap((prev) => ({ ...prev, [deliv._id]: deliv }))
            // Keep the parent's cached activity.deliverables in sync now that the backend has
            // linked this deliverable — otherwise it stays stale until some unrelated refresh.
            forceParentRefresh(true)
        }
    }

    function onDeliverableChange(id, field, value) {
        setNewDeliverablesMap((prev) => ({
            ...prev,
            [id]: { ...prev[id], [field]: value },
        }))
    }

    function handleCancel() {
        setNewDeliverablesMap({ ...deliverablesMap })
        setEditing(false)
    }

    const handlePublicationCheckboxes = (event) => {
        setNewPublication({
            ...newPublication,
            [event.target.name]: event.target.checked,
        })
    }

    function handleDeleteModalClose() {
        setOpenDeleteModal(false)
    }

    function handleDeleteModalOpen() {
        setOpenDeleteModal(true)
    }

    function handleCloseErrorModal() {
        setOpenErrorModal(false)
    }

    async function updateDependencies() {
        const checked = Object.keys(checkedActivitiesMap).filter((id) => checkedActivitiesMap[id])

        await updateActivityMutation({
            activityId: activity._id,
            roadmapId: strategy._id,
            data: { activityDependencies: checked },
        })

        invalidateLinkingQueries()
        setOpenDependencyModal(false)

        setDependencyList(allOtherActivities.filter((act) => checked.includes(act._id)))

        const newMap = {}
        allOtherActivities.forEach((act) => {
            newMap[act._id] = checked.includes(act._id)
        })
        setCheckedActivitiesMap(newMap)

        forceParentRefresh(true)
    }

    async function addPrimaryEvidence(evidenceId) {
        let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        await callAPI(
            endpoints.addPrimaryEvidenceToActivity.url + activity._id + '/' + evidenceId,
            endpoints.addPrimaryEvidenceToActivity.method,
            token
        )
    }

    async function removePrimaryEvidence(evidenceId) {
        let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        await callAPI(
            endpoints.removePrimaryEvidenceToActivity.url + activity._id + '/' + evidenceId,
            endpoints.removePrimaryEvidenceToActivity.method,
            token
        )
    }

    async function deleteDeliverable(id) {
        let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        if (!id.length) {
            return
        }
        const response = await callAPI(
            endpoints.deleteDeliverableById.url + id + '/' + activity._id,
            endpoints.deleteDeliverableById.method,
            token
        )
        if (!response.success) {
            setSaveError(response.error ?? 'Failed to delete deliverable')
            return
        }
        let tempMap = { ...newDeliverablesMap }
        delete tempMap[id]
        let tempOldMap = { ...deliverablesMap }
        delete tempOldMap[id]
        setNewDeliverablesMap(tempMap)
        setDeliverablesMap(tempOldMap)
        setOpenDeliverableDeleteModal(false)
        setSaveError(null)
        // Keep the parent's cached activity.deliverables in sync now that the backend has
        // unlinked this deliverable — otherwise it stays stale until some unrelated refresh.
        forceParentRefresh(true)
    }

    function handleQuarterOrMonthToggle(event, quarterOrMonth) {
        if (quarterOrMonth !== null) {
            setQuarterOrMonth(quarterOrMonth)
        }
        setNewStartDateCalendar(startDateCalendar)
        setNewEndDateCalendar(endDateCalendar)
        setNewStartDate(startDate)
        setNewEndDate(endDate)
    }

    function addToStack() {
        let arr = Array.from(navigationStack)
        arr.push({
            path: '/activities',
            data: activity,
        })
        return arr
    }

    const { getActivityStatusDetails, activityStatusDetails } = useActivityStatuses()
    const newActivityStatusDetails = getActivityStatusDetails(newStatusValue)

    return (
        <Fade in={isLoaded} timeout={800}>
            <Grid
                container
                direction="column"
                item
                sx={{ m: 0, backgroundColor: isDarkMode ? '#363943' : 'white' }}
                spacing={2}
            >
                <Dialog
                    open={openDeleteModal}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={handleDeleteModalClose}
                    aria-labelledby="alert-dialog-slide-title6"
                    aria-describedby="alert-dialog-slide-description6"
                >
                    <DialogTitle id="alert-dialog-slide-title6">
                        <Typography variant="h4">{`Are you sure you want to delete this ${activitiesDisplayName.singular}?`}</Typography>
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={handleDeleteModalClose} sx={{ mb: 1 }} variant="outlined-sm-button">
                            CANCEL
                        </Button>
                        <Button onClick={deleteTheActivity} sx={{ mb: 1, mr: 1 }} variant="contained-sm-button">
                            DELETE
                        </Button>
                    </DialogActions>
                </Dialog>

                {editing ? (
                    <ActivityForm
                        mode={'Edit'}
                        activity={activity}
                        onSubmit={saveActivity}
                        onCancel={handleCancel}
                        deliverables={Object.values(newDeliverablesMap)}
                        onNewDeliverable={onNewDeliverable}
                        onDeliverableChange={onDeliverableChange}
                        onDeliverableDelete={deleteDeliverable}
                        onEditDependencies={() => setOpenDependencyModal(true)}
                        onDelete={handleDeleteModalOpen}
                    />
                ) : (
                    <Box sx={{ px: 3, py: 2 }}>
                        {activity.isOwner === false && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    backgroundColor: 'figma.primary3',
                                    borderRadius: '8px',
                                    px: 2,
                                    py: 1,
                                    mb: 2,
                                }}
                            >
                                <InfoOutlinedIcon sx={{ fontSize: 16, color: 'figma.primary', flexShrink: 0 }} />
                                <Typography variant="14x400" sx={{ color: 'figma.grayscale.textHier1' }}>
                                    {`Edit mode is disabled. Please visit the source roadmap${activity.ownerRoadmapName ? ` ${activity.ownerRoadmapName}` : ''} to make changes to activity fields.`}
                                </Typography>
                            </Box>
                        )}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                            {activity.lastSyncedAt && (
                                <Typography variant="12x400" sx={{ color: 'figma.grayscale.tier3' }}>
                                    Last synced: {new Date(activity.lastSyncedAt).toLocaleDateString()}
                                </Typography>
                            )}
                            {activity.updatedAt && (
                                <Typography variant="12x400" sx={{ color: 'figma.grayscale.tier3' }}>
                                    Last updated: {new Date(activity.updatedAt).toLocaleDateString()}
                                </Typography>
                            )}
                        </Box>
                        {/* Status + Last updated + Funded */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                            {/* Study Number + External ID */}
                            {(studyNumber || activity.externalId || newActivityStatusDetails) && (
                                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', mb: 2 }}>
                                    {/* Left side — Study Number + External ID */}
                                    <Box sx={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                                        {studyNumber && (
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    gap: 1,
                                                }}
                                            >
                                                <Typography variant="16x600" sx={{ color: 'figma.grayscale.tier3' }}>
                                                    Study Number:
                                                </Typography>
                                                <Chip
                                                    sx={{
                                                        padding: '2px',
                                                        borderRadius: '30px',
                                                        backgroundColor: 'figma.primary3',
                                                        '& .MuiChip-label': { opacity: 1 },
                                                    }}
                                                    label={<Typography variant="14x400">{studyNumber}</Typography>}
                                                    size="small"
                                                />
                                            </Box>
                                        )}
                                        {activity.externalId && (
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    gap: 1,
                                                }}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: 'figma.grayscale.tier3',
                                                    }}
                                                >
                                                    External ID:
                                                </Typography>
                                                <Chip
                                                    sx={{
                                                        padding: '2px',
                                                        borderRadius: '30px',
                                                        backgroundColor: 'figma.primary3',
                                                        '& .MuiChip-label': { opacity: 1 },
                                                    }}
                                                    label={
                                                        <Typography variant="body2">{activity.externalId}</Typography>
                                                    }
                                                    size="small"
                                                />
                                            </Box>
                                        )}
                                        {source && (
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    gap: 1,
                                                }}
                                            >
                                                <Typography variant="body2" sx={{ color: 'figma.grayscale.tier3' }}>
                                                    Source:
                                                </Typography>
                                                <Chip
                                                    sx={{
                                                        ...SOURCE_CHIP_SX(
                                                            ACTIVITY_SOURCE_CHIP_COLORS[source.toUpperCase()] ??
                                                                'figma.primary3'
                                                        ),
                                                        flexShrink: 0,
                                                        fontSize: '0.7rem',
                                                        height: 22,
                                                    }}
                                                    label={source}
                                                    size="small"
                                                />
                                            </Box>
                                        )}
                                    </Box>

                                    {/* Right side — Status pushed to the end */}
                                    {newActivityStatusDetails?.id && (
                                        <Chip
                                            sx={{
                                                padding: '2px',
                                                borderRadius: '30px',
                                                backgroundColor: 'figma.primary3',
                                                '& .MuiChip-label': { opacity: 1 },
                                                ml: 'auto', // pushes to far right
                                            }}
                                            icon={
                                                <SvgIcon
                                                    component={newActivityStatusDetails.icon}
                                                    inheritViewBox
                                                    fontSize="small"
                                                />
                                            }
                                            label={
                                                <Typography variant="body2">{newActivityStatusDetails.name}</Typography>
                                            }
                                            size="small"
                                        />
                                    )}
                                </Box>
                            )}
                        </Box>

                        {/* Short Title */}
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="16x600" sx={{ color: 'figma.grayscale.tier3', mb: 0.5 }}>
                                Short Title
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                {activityTitle || '—'}
                            </Typography>
                        </Box>

                        {/* Long Title */}
                        {titleLong && (
                            <Box sx={{ mb: 2 }}>
                                <Typography
                                    variant="16x600"
                                    sx={{
                                        color: 'figma.grayscale.tier3',
                                        mb: 0.5,
                                    }}
                                >
                                    Long Title
                                </Typography>
                                <Typography variant="body2">{titleLong}</Typography>
                            </Box>
                        )}

                        {/* Objective */}
                        <Typography variant="body1" sx={{ fontWeight: 700 }}>
                            Objective
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'figma.grayscale.tier3', whiteSpace: 'pre-line' }}>
                            {description && description.length > 1 ? description : 'No objective/rationale to display'}
                        </Typography>

                        {/* Details */}
                        <Accordion
                            disableGutters
                            elevation={0}
                            defaultExpanded
                            sx={{
                                mb: 1,
                                '&:before': { display: 'none' },
                                '& .MuiAccordionSummary-root': {
                                    backgroundColor: 'inherit',
                                },
                            }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                sx={{ px: 0, minHeight: 40, '& .MuiAccordionSummary-content': { my: 0 } }}
                            >
                                <Typography variant="18x600">Details</Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ px: 0, pt: 0, pb: 1 }}>
                                <Stack spacing={2}>
                                    {/* Activity Type */}
                                    <Box justifyContent="sp" display="flex" sx={{ gap: 1 }}>
                                        <Typography
                                            variant="16x600"
                                            sx={{
                                                color: 'figma.grayscale.tier3',
                                                mb: 0.5,
                                            }}
                                        >
                                            Activity Type
                                        </Typography>
                                        <Chip
                                            size="small"
                                            label={type || '---'}
                                            sx={{ borderRadius: '30px', backgroundColor: 'figma.primary3' }}
                                        />
                                    </Box>

                                    {/* Dates row */}
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', flexWrap: 'wrap', gap: 2 }}>
                                        <Box>
                                            <Typography
                                                variant="16x600"
                                                sx={{ color: 'figma.grayscale.tier3', mb: 0.5 }}
                                            >
                                                Actual Start Date
                                            </Typography>
                                            <Typography variant="body2">
                                                {startDate
                                                    ? `${new Date(startDate).getFullYear()}, Q${quarterOfYear(new Date(startDate))}`
                                                    : startDateCalendar
                                                      ? startDateCalendar.format('MM/DD/YYYY')
                                                      : ''}
                                            </Typography>
                                        </Box>
                                        <Divider orientation="vertical" flexItem />
                                        <Box>
                                            <Typography
                                                variant="16x600"
                                                sx={{ color: 'figma.grayscale.tier3', mb: 0.5 }}
                                            >
                                                Actual End Date
                                            </Typography>
                                            <Typography variant="body2">
                                                {endDate
                                                    ? `${new Date(endDate).getFullYear()}, Q${quarterOfYear(new Date(endDate))}`
                                                    : endDateCalendar
                                                      ? endDateCalendar.format('MM/DD/YYYY')
                                                      : ''}
                                            </Typography>
                                        </Box>
                                        <Divider orientation="vertical" flexItem />
                                        <Box>
                                            <Typography
                                                variant="16x600"
                                                sx={{ color: 'figma.grayscale.tier3', mb: 0.5 }}
                                            >
                                                Planned Start Date
                                            </Typography>
                                            <Typography variant="body2">
                                                {plannedStartDate ? plannedStartDate.format('MM/DD/YYYY') : ''}
                                            </Typography>
                                        </Box>
                                        <Divider orientation="vertical" flexItem />
                                        <Box>
                                            <Typography
                                                variant="16x600"
                                                sx={{ color: 'figma.grayscale.tier3', mb: 0.5 }}
                                            >
                                                Planned End Date
                                            </Typography>
                                            <Typography variant="body2">
                                                {plannedEndDate ? plannedEndDate.format('MM/DD/YYYY') : ''}
                                            </Typography>
                                        </Box>
                                        <Divider orientation="vertical" flexItem />
                                        <Box>
                                            <Typography
                                                variant="16x600"
                                                sx={{ color: 'figma.grayscale.tier3', mb: 0.5 }}
                                            >
                                                FSR Actual Date
                                            </Typography>
                                            <Typography variant="body2">
                                                {studyReportDate ? studyReportDate.format('MM/DD/YYYY') : ''}
                                            </Typography>
                                        </Box>
                                        <Divider orientation="vertical" flexItem />
                                        <Box>
                                            <Typography
                                                variant="16x600"
                                                sx={{ color: 'figma.grayscale.tier3', mb: 0.5 }}
                                            >
                                                Terminated On Date
                                            </Typography>
                                            <Typography variant="body2">
                                                {terminationDate ? terminationDate.format('MM/DD/YYYY') : ''}
                                            </Typography>
                                        </Box>
                                        <Divider orientation="vertical" flexItem />
                                        <Box>
                                            <Typography
                                                variant="16x600"
                                                sx={{ color: 'figma.grayscale.tier3', mb: 0.5 }}
                                            >
                                                Results Available for External Use
                                            </Typography>
                                            <Typography variant="body2">
                                                {resultsAvailableForExternalUseDate
                                                    ? resultsAvailableForExternalUseDate.format('MM/DD/YYYY')
                                                    : ''}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    {/* Timeline progress bar */}
                                    {startDate && endDate && <DateProgressBar dates={{ startDate, endDate }} />}

                                    {/* Budget + Funded */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Typography
                                            variant="16x600"
                                            sx={{
                                                color: 'figma.grayscale.tier3',
                                                mb: 0.5,
                                            }}
                                        >
                                            Budget
                                        </Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                                            <Chip
                                                size="small"
                                                label={
                                                    isReadonlyMode ? '[redacted]' : `${budget?.toLocaleString() ?? '—'}`
                                                }
                                                sx={{ borderRadius: '30px', backgroundColor: 'figma.primary3' }}
                                            />
                                            {funded && (
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Typography>Funded:</Typography>
                                                    <Chip
                                                        size="small"
                                                        label="Funded"
                                                        color="success"
                                                        sx={{
                                                            borderRadius: '30px',
                                                            backgroundColor: 'figma.accentColors.green',
                                                        }}
                                                    />
                                                </Box>
                                            )}
                                        </Box>
                                    </Box>

                                    {/* Category */}
                                    <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
                                        <Typography variant="16x600" sx={{ color: 'figma.grayscale.tier3' }}>
                                            Category
                                        </Typography>
                                        <Chip
                                            size="small"
                                            label={category || '---'}
                                            sx={{ borderRadius: '30px', backgroundColor: 'figma.primary3' }}
                                        />
                                    </Box>

                                    {/* Data Source + Link */}
                                    <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
                                        <Typography
                                            variant="16x600"
                                            sx={{
                                                color: 'figma.grayscale.tier3',
                                                mb: 0.5,
                                            }}
                                        >
                                            Data Source
                                        </Typography>
                                        <Chip
                                            size="small"
                                            label={dataSource || '---'}
                                            sx={{ borderRadius: '30px', backgroundColor: 'figma.primary3' }}
                                        />
                                    </Box>
                                    {link && (
                                        <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
                                            <Typography variant="16x600" sx={{ color: 'figma.grayscale.tier3' }}>
                                                Link
                                            </Typography>
                                            <Link
                                                variant="body2"
                                                underline="hover"
                                                href={link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {link.length > 55 ? link.slice(0, 55) + '...' : link}
                                            </Link>
                                        </Box>
                                    )}

                                    {/* Function */}
                                    <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
                                        <Typography variant="16x600" sx={{ color: 'figma.grayscale.tier3' }}>
                                            Function
                                        </Typography>
                                        <Chip
                                            size="small"
                                            label={isFunction || '---'}
                                            sx={{ borderRadius: '30px', backgroundColor: 'figma.primary3' }}
                                        />
                                    </Box>

                                    {/* Population */}
                                    <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
                                        <Typography variant="16x600" sx={{ color: 'figma.grayscale.tier3' }}>
                                            Population
                                        </Typography>
                                        <Chip
                                            size="small"
                                            label={population || '---'}
                                            sx={{ borderRadius: '30px', backgroundColor: 'figma.primary3' }}
                                        />
                                    </Box>

                                    {/* Anticipated Messaging */}
                                    <Box>
                                        <Typography
                                            variant="16x600"
                                            sx={{
                                                color: 'figma.grayscale.tier3',
                                                mb: 0.5,
                                            }}
                                        >
                                            Anticipated Messaging
                                        </Typography>
                                        <Typography variant="body2">{anticipatedMessaging || '—'}</Typography>
                                    </Box>

                                    {/* Outcomes / Endpoints */}
                                    <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
                                        <Typography
                                            variant="16x600"
                                            sx={{
                                                color: 'figma.grayscale.tier3',
                                                mb: 0.5,
                                            }}
                                        >
                                            Outcomes / Endpoints
                                        </Typography>
                                        <Chip
                                            size="small"
                                            label={outcomesEndpoints || '-'}
                                            sx={{ borderRadius: '30px' }}
                                        />
                                    </Box>

                                    {/* Has Publication */}
                                    <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
                                        <Typography variant="16x600" sx={{ color: 'figma.grayscale.tier3' }}>
                                            Has Publication
                                        </Typography>
                                        <Chip
                                            size="small"
                                            label={isPublication ? 'Yes' : 'No'}
                                            sx={{ borderRadius: '30px', backgroundColor: 'figma.accentColors.green' }}
                                        />
                                    </Box>

                                    {/* Publication Types */}
                                    {Object.keys(publication).filter(
                                        (pub) => publication[pub] && pub !== 'isPublication'
                                    ).length > 0 && (
                                        <Box display="flex" alignItems="center" sx={{ gap: 1, flexWrap: 'wrap' }}>
                                            <Typography
                                                variant="16x600"
                                                sx={{ color: 'figma.grayscale.tier3', flexShrink: 0 }}
                                            >
                                                Publication Types
                                            </Typography>
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                {Object.keys(publication).map((pub) => {
                                                    if (publication[pub] && pub !== 'isPublication') {
                                                        return (
                                                            <Chip
                                                                key={pub}
                                                                size="small"
                                                                label={newLabelMapping[pub] ?? pub}
                                                                sx={{
                                                                    borderRadius: '30px',
                                                                    backgroundColor: 'figma.primary3',
                                                                }}
                                                            />
                                                        )
                                                    }
                                                    return null
                                                })}
                                            </Box>
                                        </Box>
                                    )}

                                    {/* Vendor Study */}
                                    <Box>
                                        <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
                                            <Typography variant="16x600" sx={{ color: 'figma.grayscale.tier3' }}>
                                                Study Details
                                            </Typography>
                                            <Chip
                                                size="small"
                                                label={isVendorStudy ? 'Outsourced' : 'Internal'}
                                                sx={{ borderRadius: '30px', backgroundColor: 'figma.primary3' }}
                                            />
                                        </Box>
                                        {isVendorStudy && vendorDetails && (
                                            <Box display="flex" alignItems="center" sx={{ gap: 1, mt: 1 }}>
                                                <Grid container item direction="column">
                                                    <Typography
                                                        variant="16x600"
                                                        sx={{ color: 'figma.grayscale.tier3' }}
                                                    >
                                                        Vendor Details
                                                    </Typography>
                                                    <Typography variant="16x400" sx={{ mt: 0.5 }}>
                                                        {vendorDetails}
                                                    </Typography>
                                                </Grid>
                                            </Box>
                                        )}
                                    </Box>

                                    {/* Intended Use */}
                                    {Object.keys(intendedUse ?? {}).some((use) => intendedUse[use]) && (
                                        <Box display="flex" alignItems="center" sx={{ gap: 1, flexWrap: 'wrap' }}>
                                            <Typography
                                                variant="16x600"
                                                sx={{ color: 'figma.grayscale.tier3', flexShrink: 0 }}
                                            >
                                                Intended Use
                                            </Typography>
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                {Object.keys(intendedUse).map((use) => {
                                                    if (intendedUse[use]) {
                                                        return (
                                                            <Chip
                                                                key={use}
                                                                size="small"
                                                                label={use}
                                                                sx={{
                                                                    borderRadius: '30px',
                                                                    backgroundColor: 'figma.primary3',
                                                                }}
                                                            />
                                                        )
                                                    }
                                                    return null
                                                })}
                                            </Box>
                                        </Box>
                                    )}

                                    {/* Compound Name */}
                                    {compoundName.length > 0 && (
                                        <Box>
                                            <Typography
                                                variant="16x600"
                                                sx={{
                                                    color: 'figma.grayscale.tier3',
                                                    mb: 0.5,
                                                }}
                                            >
                                                Compound Name
                                            </Typography>
                                            <Typography variant="body2">{compoundName.join(', ')}</Typography>
                                        </Box>
                                    )}

                                    {/* Generic Name */}
                                    {genericName.length > 0 && (
                                        <Box>
                                            <Typography
                                                variant="16x600"
                                                sx={{
                                                    color: 'figma.grayscale.tier3',
                                                    mb: 0.5,
                                                }}
                                            >
                                                Generic Name
                                            </Typography>
                                            <Typography variant="body2">{genericName.join(', ')}</Typography>
                                        </Box>
                                    )}

                                    {/* Affiliate + Provider */}
                                    <Box sx={{ display: 'flex', gap: 4 }}>
                                        {affiliateName && (
                                            <Box>
                                                <Typography
                                                    variant="16x600"
                                                    sx={{
                                                        color: 'figma.grayscale.tier3',
                                                        mb: 0.5,
                                                    }}
                                                >
                                                    Affiliate Name
                                                </Typography>
                                                <Typography variant="body2">{affiliateName}</Typography>
                                            </Box>
                                        )}
                                        {providerName && (
                                            <Box>
                                                <Typography
                                                    variant="16x600"
                                                    sx={{
                                                        color: 'figma.grayscale.tier3',
                                                        mb: 0.5,
                                                    }}
                                                >
                                                    {providerNameLabel}
                                                </Typography>
                                                <Typography variant="body2">{providerName}</Typography>
                                            </Box>
                                        )}
                                    </Box>

                                    {/* Sponsor Type */}
                                    <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
                                        <Typography variant="16x600" sx={{ color: 'figma.grayscale.tier3' }}>
                                            Sponsor Type
                                        </Typography>
                                        <Chip
                                            size="small"
                                            label={sponsorType || '---'}
                                            sx={{ borderRadius: '30px', backgroundColor: 'figma.primary3' }}
                                        />
                                    </Box>

                                    {/* Corporate or R&D Goal */}
                                    <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
                                        <Typography variant="16x600" sx={{ color: 'figma.grayscale.tier3' }}>
                                            Corporate or R&amp;D Goal
                                        </Typography>
                                        <Chip
                                            size="small"
                                            label={corporateOrRnDGoal ? 'Yes' : 'No'}
                                            sx={{ borderRadius: '30px', backgroundColor: 'figma.primary3' }}
                                        />
                                    </Box>

                                    {/* Countries */}
                                    {countries.length > 0 && (
                                        <Box>
                                            <Typography
                                                variant="16x600"
                                                sx={{
                                                    color: 'figma.grayscale.tier3',
                                                    mb: 0.5,
                                                }}
                                            >
                                                Countries
                                            </Typography>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    alignItems: 'center',
                                                    backgroundColor: isDarkMode ? '#3B3F4D' : '#D3D5DB',
                                                    borderRadius: '16px',
                                                    width: 'max-content',
                                                    maxWidth: '100%',
                                                    pt: 0.5,
                                                    pb: 0.5,
                                                }}
                                            >
                                                {countries.map((c) => {
                                                    const { code, label } = resolveCountry(c)
                                                    return code ? (
                                                        <ReactCountryFlag
                                                            key={c}
                                                            countryCode={code}
                                                            svg
                                                            cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                                                            cdnSuffix="svg"
                                                            style={{
                                                                width: '1.7em',
                                                                height: '1.7em',
                                                                margin: 8,
                                                            }}
                                                            title={label}
                                                            className="countryFlag"
                                                        />
                                                    ) : (
                                                        <Typography key={c} sx={{ mx: 1 }}>
                                                            {label}
                                                        </Typography>
                                                    )
                                                })}
                                            </Box>
                                        </Box>
                                    )}

                                    {/* Indication */}
                                    {indication && (
                                        <Box>
                                            <Typography
                                                variant="16x600"
                                                sx={{
                                                    color: 'figma.grayscale.tier3',
                                                    mb: 0.5,
                                                }}
                                            >
                                                Indication
                                            </Typography>
                                            <Typography variant="body2">{indication}</Typography>
                                        </Box>
                                    )}

                                    {/* Therapeutic Area */}
                                    {therapeuticArea && (
                                        <Box>
                                            <Typography
                                                variant="16x600"
                                                sx={{
                                                    color: 'figma.grayscale.tier3',
                                                    mb: 0.5,
                                                }}
                                            >
                                                Therapeutic Area
                                            </Typography>
                                            <Typography variant="body2">{therapeuticArea}</Typography>
                                        </Box>
                                    )}
                                </Stack>
                            </AccordionDetails>
                        </Accordion>

                        {/* Deliverables */}
                        <Accordion
                            disableGutters
                            elevation={0}
                            defaultExpanded
                            sx={{
                                mb: 1,
                                '&:before': { display: 'none' },
                                '& .MuiAccordionSummary-root': {
                                    backgroundColor: 'inherit',
                                },
                            }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                sx={{ px: 0, minHeight: 40, '& .MuiAccordionSummary-content': { my: 0 } }}
                            >
                                <Typography variant="body1" sx={{ fontWeight: 700 }}>
                                    Deliverables
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ px: 0, pt: 0, pb: 1 }}>
                                {Object.keys(deliverablesMap).length > 0 ? (
                                    <TableContainer component={Paper} sx={{ borderRadius: '8px', boxShadow: 0 }}>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    {columns.map((column, i) => (
                                                        <TableCell
                                                            key={'actColumn' + i}
                                                            sx={{
                                                                fontWeight: 600,
                                                                fontSize: '0.75rem',
                                                            }}
                                                        >
                                                            {column.label}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {Object.keys(deliverablesMap).map((row, i) => (
                                                    <TableRow key={'actRow' + i} className={classes.delRows}>
                                                        <TableCell>{deliverablesMap[row].title}</TableCell>
                                                        <TableCell>
                                                            {deliverablesMap[row].type && (
                                                                <Chip
                                                                    label={
                                                                        <Typography variant="14x400">
                                                                            {deliverablesMap[row].type}
                                                                        </Typography>
                                                                    }
                                                                    size="small"
                                                                    sx={{
                                                                        borderRadius: '30px',
                                                                        backgroundColor: 'figma.grayscale.tier6',
                                                                        '& .MuiChip-label': { opacity: 1 },
                                                                    }}
                                                                />
                                                            )}
                                                        </TableCell>
                                                        <TableCell>
                                                            <Chip
                                                                label={
                                                                    <Typography variant="14x400">
                                                                        {deliverablesMap[row].isComplete
                                                                            ? 'Completed'
                                                                            : 'Incomplete'}
                                                                    </Typography>
                                                                }
                                                                size="small"
                                                                sx={{
                                                                    borderRadius: '30px',
                                                                    backgroundColor: deliverablesMap[row].isComplete
                                                                        ? 'figma.accentColors.green'
                                                                        : 'figma.accentColors.red',
                                                                    color: 'white',
                                                                    '& .MuiChip-label': { opacity: 1 },
                                                                }}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                ) : (
                                    <Typography variant="body2" sx={{ color: 'figma.grayscale.tier3' }}>
                                        No deliverables to display
                                    </Typography>
                                )}
                            </AccordionDetails>
                        </Accordion>

                        {/* Study Owner */}
                        {studyOwner && (
                            <Box sx={{ mb: 2 }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: 'figma.grayscale.tier3',
                                        mb: 0.5,
                                    }}
                                >
                                    Study Contact
                                </Typography>
                                <Typography variant="body2">{studyOwner}</Typography>
                            </Box>
                        )}
                    </Box>
                )}

                <Stack direction="row" p={3}>
                    {/* Any roadmap holding a join to this Activity may link its own items to it,
                        owner or imported: ownership only gates editing the Activity's own fields
                        above, not linking. See writerStrategyId in linking-helpers.js. */}
                    <Linking
                        type="activity"
                        id={activity._id}
                        roadmapId={strategy._id}
                        previousDataStack={addToStack()}
                    />
                </Stack>

                <Snackbar
                    open={!!saveError}
                    autoHideDuration={6000}
                    onClose={() => setSaveError(null)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                    <Alert onClose={() => setSaveError(null)} severity="error" sx={{ width: '100%' }}>
                        {saveError}
                    </Alert>
                </Snackbar>

                <Dialog
                    open={openErrorModal}
                    onClose={handleCloseErrorModal}
                    aria-labelledby="alert-dialog-title2"
                    aria-describedby="alert-dialog-description2"
                >
                    <DialogTitle id="alert-dialog-slide-title">Error</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Please select an End Date that occurs after the Start Date
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseErrorModal}>OK</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openDependencyModal}
                    onClose={() => setOpenDependencyModal(false)}
                    aria-labelledby="alert-dialog-title3"
                    aria-describedby="alert-dialog-description3"
                >
                    <DialogTitle id="alert-dialog-slide-title">Dependencies</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Select {activitiesDisplayName.singular} Dependent on "{activityTitle}"
                        </DialogContentText>
                        <Fade in={isLoaded}>
                            <FormControl component="fieldset" className={classes.formControl}>
                                {allOtherActivities &&
                                    allOtherActivities.length &&
                                    allOtherActivities.map((act, i) => (
                                        <div key={'actDV' + i}>
                                            <FormControlLabel
                                                control={
                                                    <BlueCheckBox
                                                        val={act._id}
                                                        color="primary"
                                                        defaultChecked={checkedActivitiesMap[act._id]}
                                                    />
                                                }
                                                label={act.title}
                                            />
                                        </div>
                                    ))}
                            </FormControl>
                        </Fade>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenDependencyModal(false)} variant="outlined">
                            Cancel
                        </Button>
                        <Button onClick={updateDependencies} variant="outlined">
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openDeliverableDeleteModal}
                    onClose={() => setOpenDeliverableDeleteModal(false)}
                    aria-labelledby="alert-dialog-title4"
                    aria-describedby="alert-dialog-description4"
                >
                    <DialogTitle id="alert-dialog-slide-title2">Delete Deliverable</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Are you sure you want to delete this deliverable?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenDeliverableDeleteModal(false)} variant="contained-sm-button">
                            Cancel
                        </Button>
                        <Button onClick={() => deleteDeliverable(deleteDeliverableId)} variant="outlined-sm-button">
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        </Fade>
    )
}

export default ActivityDetailedView
